import styles from "./Contactusform.module.scss";
import { useState } from "react";
// import sendDiningForm from "../../../lib/sendDiningForm";
// import useDiningForm from "../../../hooks/useDiningForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DiningPageForm() {
    const [selectDate, setSelectDate] = useState(new Date());
    const [selectedOption, setSelectedOption] = useState('');
    const [form, setForm] = useState('');

    const [diningFormData, setDiningFormData] = useState({
        fullname: '',
        email: '',
        phoneno: '',
        message: ''
    });

    const handleDataChange = (e) => {
        const { name, value } = e.target;
        setDiningFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const datenmonth = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    });

    const handleDateChange = (date) => {
        setSelectDate(date);
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        setForm({ state: 'loading' })
        try {
            const dataToSend = {
                ...diningFormData,
                date: selectDate,
                selectedOption: selectedOption
            }
            const res = await fetch(`/api/senddiningform`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            })
            const { error } = await res.json();

            if (error) {
                setForm({
                    state: 'error',
                    message: error,
                })
                return
            }

            setForm({
                state: 'success',
                message: 'Your message was sent successfully.',
            })
            setDiningFormData({
                fullname: '',
                email: '',
                phoneno: '',
                message: '',
            });
            selectedOption('');
        } catch (error) {
            setForm({
                state: 'error',
                message: 'Something went wrong',
            })
        }
    };

    return (
        <>
            <section className={`${styles.form} common_padding `}>
                <div className="row justify-content-center">
                    <div >
                        <h3 className='text-center'>Book Your Table</h3>
                    </div>

                    <div className="col-md-7 col-sm-12 contact_form">
                        <form className="row" onSubmit={handleSubmit}>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="fullname"
                                    type="text"
                                    name="fullname"
                                    onChange={handleDataChange}
                                    value={diningFormData.fullname}
                                    className="form-control"
                                    placeholder="Full Name"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={handleDataChange}
                                    value={diningFormData.email}
                                    className="form-control"
                                    placeholder="Your Email"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <input
                                    id="phoneno"
                                    required
                                    name="phoneno"
                                    type="number"
                                    onChange={handleDataChange}
                                    value={diningFormData.phoneno}
                                    className="form-control"
                                    placeholder="Phone Number"
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <DatePicker wrapperClassName="diningform-date-picker"
                                    minDate={new Date()}
                                    className={styles.form_control}
                                    selected={selectDate}
                                    onChange={handleDateChange}
                                    placeholderText={'Please select a date'}
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <div className="dining-radio-input">
                                    <p className="m-0"><strong>Booking For:</strong></p>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Restaurant"
                                            checked={selectedOption === 'Restaurant'}
                                            onChange={handleOptionChange}
                                        />
                                        Restaurant
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Bar"
                                            checked={selectedOption === 'Bar'}
                                            onChange={handleOptionChange}
                                        />
                                        Bar
                                    </label>
                                </div>
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <textarea
                                    id="message"
                                    name="message"
                                    onChange={handleDataChange}
                                    value={diningFormData.message}
                                    className="form-control"
                                    placeholder="Message"
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className="common_btn">SEND REQUEST</button>
                            {form.state === 'loading' ? (
                                <div>Sending....</div>
                            ) : form.state === 'error' ? (
                                <div className="form_message error">{form.message}</div>
                            ) : (
                                form.state === 'success' && <div className="form_message success">Thankyou! Your Message has been delivered.</div>
                            )}
                            {/* {formMessage.state === 'loading' ? (
                                <div>Sending....</div>
                            ) : formMessage.state === 'error' ? (
                                <div className="form_message error">Something went wrong! Try again later.</div>
                            ) : (
                                formMessage.state === 'success' && <div className="success">Thankyou! Your Message has been delivered.</div>
                            )} */}
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}
